import AuthDialog from "@/components/auth-dialog";
import PublicLayout from "@/components/public-layout";

import { ArrowRight, Upload, CheckCircle, Signature } from "lucide-react";

export default function Landing() {
  return (
    <PublicLayout>
      <section className="mx-auto flex-grow flex flex-col-reverse md:flex-row items-center justify-between py-8 md:py-16">
        <div className="w-full md:w-1/2 md:pr-12 text-center md:text-left">
          <h1 className="text-3xl md:text-5xl font-extrabold mb-4 md:mb-6 leading-tight">
            Odszkodowania za opóźnienia pociągów{" "}
            <span className="text-blue-600">bez stresu</span>
          </h1>
          <p className="text-base md:text-xl mb-6 md:mb-8 leading-relaxed">
            Prześlij bilet oraz informacje o opóźnieniu pociągu, a nasz system
            sam obliczy odszkodowanie i przygotuje wniosek do PKP.
          </p>

          <div className="space-y-4 md:space-y-5">
            {[
              {
                icon: <Upload className="w-5 h-5 text-blue-600" />,
                bgColor: "bg-blue-100",
                title: "Dodaj bilet",
                description: "Przeslij bilet w formacie PDF, lub jego zdjęcie.",
              },
              {
                icon: <CheckCircle className="w-5 h-5 text-blue-600" />,
                bgColor: "bg-blue-100",
                title: "Zautomatyzowany proces",
                description:
                  "System sam przygotowuje wniosek i obliczy odszkodowanie.",
              },
              {
                icon: <Signature className="w-5 h-5 text-blue-600" />,
                bgColor: "bg-blue-100",
                title: "Prostota obslugi",
                description: "Ty musisz tylko podpisać gotowy dokument.",
              },
            ].map((feature, index) => (
              <AuthDialog key={index} ghost>
                <div
                  key={index}
                  className="flex items-center bg-primary text-white p-3 md:p-4 rounded-xl shadow-md hover:bg-blue-700 transition border border-white cursor-pointer"
                >
                  <div
                    className={`${feature.bgColor} p-2 md:p-3 rounded-full mr-3 md:mr-4`}
                  >
                    {feature.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold  text-sm md:text-base">
                      {feature.title}
                    </h3>
                    <p className="text-xs md:text-sm">{feature.description}</p>
                  </div>
                </div>
              </AuthDialog>
            ))}
          </div>

          <div className="mt-6 md:mt-10 flex justify-center md:justify-start space-x-4">
            <AuthDialog>
              Odbierz odszkodowanie <ArrowRight className="ml-2 w-4 h-4" />
            </AuthDialog>
            <button className="border-2 border-blue-600 text-blue-600 px-4 py-2 rounded-full hover:bg-blue-50 transition">
              Obejrzyj demo
            </button>
          </div>
        </div>

        <div className="w-full md:w-1/2 mb-8 md:mb-0 flex justify-center">
          <div className="bg-white p-3 md:p-4 rounded-2xl shadow-2xl w-full max-w-md">
            <img
              src="/example1.png"
              alt="interfejs aplikacji"
              className="rounded-xl shadow-lg w-full"
            />
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
